export default __webpack_public_path__ + "static/media/icon2.28fafb7e.svg";